/* ==========================================================================
   Frileux Motion — animations & panier (vanilla JS, sans dépendance)
   ========================================================================== */
(() => {
  'use strict';

  const T = window.theme || { settings: {}, strings: {}, routes: {} };
  const $ = (s, c = document) => c.querySelector(s);
  const $$ = (s, c = document) => Array.from(c.querySelectorAll(s));
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const finePointer = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  const clamp = (v, a, b) => Math.min(b, Math.max(a, v));
  const lerp = (a, b, t) => a + (b - a) * t;

  const store = {
    get(k) { try { return window.sessionStorage.getItem(k); } catch (e) { return null; } },
    set(k, v) { try { window.sessionStorage.setItem(k, v); } catch (e) { /* stockage indisponible */ } }
  };

  const money = (cents) => {
    try {
      return new Intl.NumberFormat(T.locale === 'en' ? 'en-US' : 'fr-FR', { style: 'currency', currency: T.currency || 'EUR' }).format(cents / 100);
    } catch (e) {
      return (cents / 100).toFixed(2).replace('.', ',') + ' €';
    }
  };

  /* ---------- Rideau d'intro ---------- */
  function initIntro() {
    const intro = $('[data-intro]');
    if (!intro) return;
    if (reduced || store.get('frileux-intro')) { intro.remove(); return; }
    intro.classList.add('is-ready');
    document.documentElement.style.overflow = 'hidden';
    store.set('frileux-intro', '1');
    setTimeout(() => {
      intro.classList.add('is-done');
      document.documentElement.style.overflow = '';
      setTimeout(() => intro.remove(), 1100);
    }, 1500);
  }

  /* ---------- Découpage du texte en mots ---------- */
  function splitText(el) {
    if (el.dataset.splitDone) return;
    el.dataset.splitDone = '1';
    let i = 0;
    const walk = (node) => {
      Array.from(node.childNodes).forEach((child) => {
        if (child.nodeType === 3) {
          const parts = child.textContent.split(/(\s+)/);
          const frag = document.createDocumentFragment();
          parts.forEach((part) => {
            if (!part) return;
            if (/^\s+$/.test(part)) { frag.appendChild(document.createTextNode(' ')); return; }
            const w = document.createElement('span');
            w.className = 'w';
            const inner = document.createElement('span');
            inner.className = 'w__i';
            inner.style.setProperty('--i', i++);
            inner.textContent = part;
            w.appendChild(inner);
            frag.appendChild(w);
          });
          child.replaceWith(frag);
        } else if (child.nodeType === 1 && child.tagName.toLowerCase() !== 'svg') {
          walk(child);
        }
      });
    };
    walk(el);
  }

  /* ---------- Apparitions au défilement ---------- */
  function initReveal() {
    $$('[data-split]').forEach(splitText);
    const targets = $$('[data-reveal], [data-split]');
    if (reduced || !('IntersectionObserver' in window)) {
      targets.forEach((t) => t.classList.add('is-in'));
      return;
    }
    const io = new IntersectionObserver((entries) => {
      entries.forEach((e) => {
        if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -6% 0px' });
    targets.forEach((t) => io.observe(t));
  }

  /* ---------- En-tête ---------- */
  function initHeader() {
    const header = $('[data-header]');
    if (!header) return;
    let last = window.scrollY;
    const onScroll = () => {
      const y = window.scrollY;
      header.classList.toggle('is-solid', y > 40);
      const goingDown = y > last && y > 260;
      header.classList.toggle('is-hidden', goingDown && !document.body.classList.contains('drawer-open'));
      last = y;
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* ---------- Boucle de défilement (parallaxe, bandeaux, scroll horizontal) ---------- */
  function initScrollFx() {
    const parallax = $$('[data-parallax]');
    const bands = $$('.band .marquee');
    const hs = $('[data-hscroll]');
    let lastY = window.scrollY;
    let velocity = 0;
    let ticking = false;

    let hsTrack, hsBar, hsDistance = 0;
    const setupHs = () => {
      if (!hs) return;
      hsTrack = $('[data-hscroll-track]', hs);
      hsBar = $('[data-hscroll-progress]', hs);
      const pin = !reduced && window.innerWidth >= 990;
      hs.classList.toggle('is-pinned', pin);
      if (pin) {
        hsTrack.style.transform = '';
        hsDistance = Math.max(0, hsTrack.scrollWidth - window.innerWidth);
        hs.style.height = (hsDistance + window.innerHeight) + 'px';
      } else {
        hs.style.height = '';
        hsTrack.style.transform = '';
        hsDistance = 0;
      }
    };

    const frame = () => {
      ticking = false;
      const y = window.scrollY;
      const vh = window.innerHeight;
      velocity = lerp(velocity, y - lastY, 0.2);
      lastY = y;

      if (!reduced) {
        parallax.forEach((el) => {
          const r = el.getBoundingClientRect();
          if (r.bottom < -200 || r.top > vh + 200) return;
          const f = parseFloat(el.dataset.parallax) || 0;
          const offset = (r.top + r.height / 2 - vh / 2) * f;
          el.style.transform = `translate3d(0, ${offset.toFixed(1)}px, 0)`;
        });
        const skew = clamp(velocity * -0.25, -8, 8);
        bands.forEach((b) => b.style.setProperty('--skew', skew.toFixed(2) + 'deg'));
      }

      if (hs && hsDistance > 0) {
        const top = hs.getBoundingClientRect().top;
        const p = clamp(-top / hsDistance, 0, 1);
        hsTrack.style.transform = `translate3d(${(-p * hsDistance).toFixed(1)}px, 0, 0)`;
        if (hsBar) hsBar.style.width = (p * 100).toFixed(1) + '%';
      } else if (hs && hsBar && hsTrack) {
        const max = hsTrack.scrollWidth - hsTrack.clientWidth;
        hsBar.style.width = max > 0 ? ((hsTrack.scrollLeft / max) * 100).toFixed(1) + '%' : '0%';
      }

      if (Math.abs(velocity) > 0.1) request();
    };
    const request = () => { if (!ticking) { ticking = true; requestAnimationFrame(frame); } };

    setupHs();
    if (hsTrack) hsTrack.addEventListener('scroll', request, { passive: true });
    window.addEventListener('scroll', request, { passive: true });
    window.addEventListener('resize', () => { setupHs(); request(); });
    window.addEventListener('load', () => { setupHs(); request(); });
    request();
  }

  /* ---------- Neige ---------- */
  function initSnow() {
    if (reduced || !T.settings.snow) return;
    $$('canvas[data-snow]').forEach((canvas) => {
      const ctx = canvas.getContext('2d');
      if (!ctx) return;
      const density = parseFloat(canvas.dataset.snowDensity) || 1;
      let w = 0, h = 0, flakes = [], running = false, raf = 0;
      const dpr = Math.min(window.devicePixelRatio || 1, 2);

      const resize = () => {
        const r = canvas.getBoundingClientRect();
        w = r.width; h = r.height;
        canvas.width = Math.round(w * dpr);
        canvas.height = Math.round(h * dpr);
        ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
        const count = Math.round(clamp((w * h) / 9000, 30, 160) * density);
        flakes = Array.from({ length: count }, () => ({
          x: Math.random() * w,
          y: Math.random() * h,
          r: Math.random() * 2.4 + 0.6,
          s: Math.random() * 0.6 + 0.25,
          d: Math.random() * Math.PI * 2,
          o: Math.random() * 0.5 + 0.35
        }));
      };

      let mouseX = 0;
      const draw = () => {
        ctx.clearRect(0, 0, w, h);
        for (const f of flakes) {
          f.d += 0.01;
          f.y += f.s + f.r * 0.15;
          f.x += Math.sin(f.d) * 0.4 + mouseX * f.r * 0.08;
          if (f.y > h + 5) { f.y = -5; f.x = Math.random() * w; }
          if (f.x > w + 5) f.x = -5;
          if (f.x < -5) f.x = w + 5;
          ctx.beginPath();
          ctx.arc(f.x, f.y, f.r, 0, Math.PI * 2);
          ctx.fillStyle = `rgba(255,255,255,${f.o})`;
          ctx.fill();
        }
        if (running) raf = requestAnimationFrame(draw);
      };

      const parent = canvas.parentElement;
      if (finePointer && parent) {
        parent.addEventListener('mousemove', (e) => {
          const r = parent.getBoundingClientRect();
          mouseX = ((e.clientX - r.left) / r.width - 0.5) * 2;
        });
      }

      resize();
      window.addEventListener('resize', resize);
      new IntersectionObserver(([e]) => {
        running = e.isIntersecting;
        cancelAnimationFrame(raf);
        if (running) draw();
      }).observe(canvas);
    });
  }

  /* ---------- Boutons magnétiques, inclinaison, curseur ---------- */
  function initPointerFx() {
    if (reduced || !finePointer) return;

    $$('.btn--magnetic').forEach((btn) => {
      btn.addEventListener('mousemove', (e) => {
        const r = btn.getBoundingClientRect();
        const x = e.clientX - r.left, y = e.clientY - r.top;
        btn.style.setProperty('--bx', x + 'px');
        btn.style.setProperty('--by', y + 'px');
        btn.style.transform = `translate(${(x - r.width / 2) * 0.18}px, ${(y - r.height / 2) * 0.3}px)`;
      });
      btn.addEventListener('mouseleave', () => { btn.style.transform = ''; });
    });

    if (T.settings.tilt) {
      $$('[data-tilt]').forEach((el) => {
        el.addEventListener('mousemove', (e) => {
          const r = el.getBoundingClientRect();
          const px = (e.clientX - r.left) / r.width, py = (e.clientY - r.top) / r.height;
          el.style.transform = `perspective(900px) rotateX(${(0.5 - py) * 7}deg) rotateY(${(px - 0.5) * 9}deg) translateY(-4px)`;
          el.style.setProperty('--mx', (px * 100).toFixed(1) + '%');
          el.style.setProperty('--my', (py * 100).toFixed(1) + '%');
        });
        el.addEventListener('mouseleave', () => { el.style.transform = ''; });
      });
    }

    const glow = $('[data-cursor]');
    if (glow && T.settings.cursor) {
      let tx = -500, ty = -500, cx = -500, cy = -500, on = false;
      window.addEventListener('mousemove', (e) => {
        tx = e.clientX; ty = e.clientY;
        if (!on) { on = true; glow.classList.add('is-on'); }
      }, { passive: true });
      document.addEventListener('mouseleave', () => { on = false; glow.classList.remove('is-on'); });
      const loop = () => {
        cx = lerp(cx, tx, 0.12); cy = lerp(cy, ty, 0.12);
        glow.style.transform = `translate3d(${cx}px, ${cy}px, 0)`;
        requestAnimationFrame(loop);
      };
      loop();
    }

    // Frileux suit la souris et grelotte au survol
    $$('[data-follow]').forEach((el) => {
      const area = el.closest('section') || document.body;
      area.addEventListener('mousemove', (e) => {
        const r = el.getBoundingClientRect();
        const dx = (e.clientX - (r.left + r.width / 2)) / window.innerWidth;
        const dy = (e.clientY - (r.top + r.height / 2)) / window.innerHeight;
        el.style.transform = `rotate(${dx * 10}deg) translate(${dx * 24}px, ${dy * 16}px)`;
      });
      el.addEventListener('mouseenter', () => el.classList.add('is-shiver'));
      el.addEventListener('mouseleave', () => el.classList.remove('is-shiver'));
    });
  }

  /* ---------- Machine à écrire ---------- */
  function initTypewriter() {
    $$('[data-typewriter]').forEach((el) => {
      const text = el.dataset.typewriter || '';
      const out = $('[data-typewriter-out]', el);
      if (!out) return;
      if (reduced) { out.textContent = text; return; }
      let started = false;
      new IntersectionObserver(([e], obs) => {
        if (!e.isIntersecting || started) return;
        started = true; obs.disconnect();
        let i = 0;
        const tick = () => {
          out.textContent = text.slice(0, ++i);
          if (i < text.length) setTimeout(tick, text[i - 1] === '…' || text[i - 1] === ',' ? 260 : 38 + Math.random() * 40);
        };
        setTimeout(tick, 400);
      }, { threshold: 0.6 }).observe(el);
    });
  }

  /* ---------- Défilement à la souris des rangées produits ---------- */
  function initDragScroll() {
    if (!finePointer) return;
    $$('[data-drag-scroll]').forEach((el) => {
      let down = false, startX = 0, startLeft = 0, moved = false;
      el.addEventListener('mousedown', (e) => {
        if (el.scrollWidth <= el.clientWidth) return;
        down = true; moved = false; startX = e.pageX; startLeft = el.scrollLeft;
      });
      window.addEventListener('mousemove', (e) => {
        if (!down) return;
        const dx = e.pageX - startX;
        if (Math.abs(dx) > 5) { moved = true; el.classList.add('is-dragging'); }
        el.scrollLeft = startLeft - dx;
      });
      window.addEventListener('mouseup', () => {
        if (!down) return;
        down = false;
        setTimeout(() => el.classList.remove('is-dragging'), 0);
      });
      el.addEventListener('click', (e) => { if (moved) { e.preventDefault(); e.stopPropagation(); } }, true);
    });
  }

  /* ---------- Accordéons animés ---------- */
  function initAccordions() {
    $$('[data-accordion]').forEach((d) => {
      const summary = $('summary', d);
      const body = $('[data-accordion-body]', d);
      if (!summary || !body || reduced) return;
      summary.addEventListener('click', (e) => {
        e.preventDefault();
        if (d.dataset.animating) return;
        d.dataset.animating = '1';
        if (!d.open) {
          d.open = true;
          const h = body.scrollHeight;
          body.animate([{ height: '0px', opacity: 0 }, { height: h + 'px', opacity: 1 }], { duration: 450, easing: 'cubic-bezier(.22,1,.36,1)' })
            .onfinish = () => { delete d.dataset.animating; };
        } else {
          const h = body.scrollHeight;
          body.animate([{ height: h + 'px', opacity: 1 }, { height: '0px', opacity: 0 }], { duration: 350, easing: 'cubic-bezier(.22,1,.36,1)' })
            .onfinish = () => { d.open = false; delete d.dataset.animating; };
        }
      });
    });
  }

  /* ---------- Menus & tiroirs ---------- */
  const overlay = $('[data-drawer-overlay]');
  let openPanel = null;
  let lastFocus = null;

  function openDrawer(panel) {
    if (!panel) return;
    closeDrawer();
    lastFocus = document.activeElement;
    openPanel = panel;
    panel.classList.add('is-open');
    panel.setAttribute('aria-hidden', 'false');
    document.body.classList.add('drawer-open');
    document.documentElement.style.overflow = 'hidden';
    if (overlay) { overlay.hidden = false; requestAnimationFrame(() => overlay.classList.add('is-visible')); }
    const focusable = panel.querySelector('button, a');
    if (focusable) setTimeout(() => focusable.focus({ preventScroll: true }), 300);
  }

  function closeDrawer() {
    if (!openPanel) return;
    openPanel.classList.remove('is-open');
    openPanel.setAttribute('aria-hidden', 'true');
    openPanel = null;
    document.body.classList.remove('drawer-open');
    document.documentElement.style.overflow = '';
    if (overlay) { overlay.classList.remove('is-visible'); setTimeout(() => { overlay.hidden = true; }, 500); }
    if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
  }

  function initMenus() {
    const nav = $('[data-mobile-nav]');
    $$('[data-mobile-open]').forEach((b) => b.addEventListener('click', () => openDrawer(nav)));
    $$('[data-mobile-close]').forEach((b) => b.addEventListener('click', closeDrawer));
    if (nav) $$('a', nav).forEach((a) => a.addEventListener('click', closeDrawer));
    if (overlay) overlay.addEventListener('click', closeDrawer);
    document.addEventListener('keydown', (e) => { if (e.key === 'Escape') closeDrawer(); });

    // Liens d'ancre : défilement doux en tenant compte de l'en-tête
    document.addEventListener('click', (e) => {
      const a = e.target.closest('a[href^="#"]');
      if (!a) return;
      const id = a.getAttribute('href').slice(1);
      const target = id && document.getElementById(id);
      if (!target) return;
      e.preventDefault();
      const top = target.getBoundingClientRect().top + window.scrollY - 70;
      window.scrollTo({ top, behavior: reduced ? 'auto' : 'smooth' });
    });

    const recover = $('[data-toggle-recover]');
    if (recover) recover.addEventListener('click', (e) => { e.preventDefault(); const box = $('#recover'); if (box) box.classList.toggle('is-open'); });

    const sort = $('[data-sort]');
    if (sort) sort.addEventListener('change', () => {
      const url = new URL(window.location.href);
      url.searchParams.set('sort_by', sort.value);
      url.searchParams.delete('page');
      window.location.href = url.toString();
    });
  }

  /* ---------- Panier ---------- */
  const drawer = $('[data-cart-drawer]');

  async function getCart() {
    const r = await fetch(T.routes.cart, { headers: { Accept: 'application/json' } });
    return r.json();
  }

  function updateCounts(count) {
    $$('[data-cart-bubble]').forEach((b) => {
      b.textContent = count;
      b.classList.toggle('is-empty', count === 0);
      b.classList.remove('is-bump'); void b.offsetWidth; b.classList.add('is-bump');
    });
    $$('[data-cart-count]').forEach((c) => { c.textContent = count; });
  }

  const esc = (s) => String(s == null ? '' : s).replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));

  function renderCart(cart) {
    if (!drawer) return;
    const body = $('[data-cart-items]', drawer);
    const total = $('[data-cart-total]', drawer);
    const checkout = $('[data-checkout]', drawer);
    updateCounts(cart.item_count);
    if (total) total.textContent = money(cart.total_price);
    if (checkout) checkout.toggleAttribute('hidden', cart.item_count === 0);
    if (!cart.items.length) {
      body.innerHTML = `<div class="cart-drawer__empty">${document.querySelector('.logo__mascot svg') ? document.querySelector('.logo__mascot').innerHTML.replace('frileux--sm', 'frileux--md') : ''}<p>${esc(T.strings.emptyCart)}</p></div>`;
      return;
    }
    body.innerHTML = cart.items.map((it, i) => {
      const img = it.image ? it.image + (it.image.indexOf('?') > -1 ? '&' : '?') + 'width=200' : '';
      const variant = it.variant_title && it.variant_title !== 'Default Title' ? `<p class="dline__variant">${esc(it.variant_title)}</p>` : '';
      return `<div class="dline" style="--i:${i}">
        <a href="${esc(it.url)}">${img ? `<img class="dline__img" src="${esc(img)}" alt="" loading="lazy">` : ''}</a>
        <div>
          <a class="dline__title" href="${esc(it.url)}">${esc(it.product_title)}</a>
          ${variant}
          <div class="dline__qty">
            <button type="button" data-line-change="${esc(it.key)}" data-qty="${it.quantity - 1}" aria-label="Moins"><svg class="icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><path d="M5 12h14"/></svg></button>
            <span>${it.quantity}</span>
            <button type="button" data-line-change="${esc(it.key)}" data-qty="${it.quantity + 1}" aria-label="Plus"><svg class="icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><path d="M12 5v14M5 12h14"/></svg></button>
          </div>
        </div>
        <p class="dline__price">${money(it.final_line_price)}</p>
      </div>`;
    }).join('');
  }

  const SPARKLE = '<svg class="icon" viewBox="0 0 24 24" aria-hidden="true" fill="currentColor"><path d="M12 2.5c.6 4.6 2.9 6.9 7.5 7.5-4.6.6-6.9 2.9-7.5 7.5-.6-4.6-2.9-6.9-7.5-7.5 4.6-.6 6.9-2.9 7.5-7.5Z"/></svg>';
  let recoKey = '';

  async function renderReco(cart) {
    const box = drawer && $('[data-cart-reco]', drawer);
    if (!box) return;
    if (!cart.items.length) { box.hidden = true; box.innerHTML = ''; recoKey = ''; return; }
    const key = cart.items.map((i) => i.product_id).join(',');
    if (key === recoKey) return;
    recoKey = key;
    const inCart = new Set(cart.items.map((i) => i.product_id));
    try {
      const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      const r = await fetch(`${root}recommendations/products.json?product_id=${cart.items[0].product_id}&limit=8&intent=related`);
      const data = await r.json();
      let list = (data.products || []).filter((p) => !inCart.has(p.id) && p.available).slice(0, 3);
      if (!list.length) {
        // Pas encore de recommandations Shopify : on propose les petits prix de la boutique
        const all = await fetch(`${root}products.json?limit=50`).then((x) => x.json());
        list = (all.products || [])
          .map((p) => {
            const variants = p.variants.map((v) => ({ id: v.id, available: v.available, price: Math.round(parseFloat(v.price) * 100) }));
            const prices = variants.map((v) => v.price);
            return {
              id: p.id, title: p.title, url: `${root}products/${p.handle}`, variants,
              available: variants.some((v) => v.available),
              price: Math.min(...prices), price_varies: Math.min(...prices) !== Math.max(...prices),
              featured_image: p.images && p.images[0] ? p.images[0].src : ''
            };
          })
          .filter((p) => !inCart.has(p.id) && p.available)
          .sort((a, b) => a.price - b.price)
          .slice(0, 3);
      }
      if (!list.length) { box.hidden = true; box.innerHTML = ''; return; }
      box.innerHTML = `<p class="reco__title">${SPARKLE} ${esc(T.strings.recoTitle)}</p><div class="reco__list">${list.map((p, i) => {
        const v = p.variants.find((x) => x.available) || p.variants[0];
        let img = p.featured_image || '';
        if (img.indexOf('//') === 0) img = 'https:' + img;
        if (img) img += (img.indexOf('?') > -1 ? '&' : '?') + 'width=160';
        const cta = p.variants.length === 1
          ? `<button class="reco__add" type="button" data-reco-add="${v.id}">${esc(T.strings.add)}</button>`
          : `<a class="reco__add" href="${esc(p.url)}">${esc(T.strings.choose)}</a>`;
        return `<div class="reco__item" style="--i:${i}">
          <a href="${esc(p.url)}">${img ? `<img class="reco__img" src="${esc(img)}" alt="" loading="lazy">` : ''}</a>
          <div><a class="reco__name" href="${esc(p.url)}">${esc(p.title)}</a><p class="reco__price">${p.price_varies ? 'dès ' : ''}${money(p.price)}</p></div>
          ${cta}
        </div>`;
      }).join('')}</div>`;
      box.hidden = false;
    } catch (e) {
      box.hidden = true;
    }
  }

  async function refreshCart(open) {
    try {
      const cart = await getCart();
      renderCart(cart);
      renderReco(cart);
      if (open) openDrawer(drawer);
    } catch (e) {
      if (open) window.location.href = T.routes.cartPage;
    }
  }

  async function addToCart(id, quantity) {
    const r = await fetch(T.routes.cartAdd, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(id), quantity: Number(quantity) || 1 }] })
    });
    const data = await r.json();
    if (!r.ok) throw new Error(data.description || data.message || T.strings.error);
    return data;
  }

  function flyToCart(fromEl) {
    if (reduced || !fromEl) return;
    const img = fromEl.closest('.card, [data-product]')?.querySelector('img');
    const cart = $('.header__cart');
    if (!img || !cart) return;
    const a = img.getBoundingClientRect(), b = cart.getBoundingClientRect();
    const clone = img.cloneNode();
    clone.removeAttribute('srcset');
    Object.assign(clone.style, {
      position: 'fixed', left: a.left + 'px', top: a.top + 'px', width: a.width + 'px', height: a.height + 'px',
      objectFit: 'cover', borderRadius: '24px', zIndex: 300, pointerEvents: 'none', margin: 0
    });
    document.body.appendChild(clone);
    const dx = b.left + b.width / 2 - (a.left + a.width / 2);
    const dy = b.top + b.height / 2 - (a.top + a.height / 2);
    clone.animate([
      { transform: 'translate(0,0) scale(1)', opacity: 1 },
      { transform: `translate(${dx * 0.6}px, ${dy * 0.3 - 80}px) scale(.45) rotate(-10deg)`, opacity: 1, offset: 0.5 },
      { transform: `translate(${dx}px, ${dy}px) scale(.08) rotate(-20deg)`, opacity: 0.4 }
    ], { duration: 850, easing: 'cubic-bezier(.5,0,.3,1)' }).onfinish = () => clone.remove();
  }

  function initCart() {
    $$('[data-cart-open]').forEach((b) => b.addEventListener('click', (e) => {
      if (!drawer || document.body.classList.contains('template-cart')) return;
      e.preventDefault();
      refreshCart(true);
    }));
    $$('[data-cart-close]').forEach((b) => b.addEventListener('click', closeDrawer));

    if (drawer) {
      drawer.addEventListener('click', async (e) => {
        const reco = e.target.closest('[data-reco-add]');
        if (reco) {
          reco.disabled = true;
          try {
            await addToCart(reco.dataset.recoAdd, 1);
            reco.classList.add('is-added');
            setTimeout(() => refreshCart(false), 350);
          } catch (err) { reco.disabled = false; }
          return;
        }
        const btn = e.target.closest('[data-line-change]');
        if (!btn) return;
        btn.disabled = true;
        try {
          const r = await fetch(T.routes.cartChange, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ id: btn.dataset.lineChange, quantity: Math.max(0, Number(btn.dataset.qty)) })
          });
          const cart = await r.json();
          renderCart(cart);
          renderReco(cart);
        } catch (err) { btn.disabled = false; }
      });
    }

    document.addEventListener('click', async (e) => {
      const btn = e.target.closest('[data-quick-add]');
      if (!btn) return;
      e.preventDefault();
      btn.disabled = true;
      try {
        await addToCart(btn.dataset.quickAdd, 1);
        btn.classList.add('is-added');
        flyToCart(btn);
        setTimeout(() => refreshCart(true), 450);
        setTimeout(() => btn.classList.remove('is-added'), 1600);
      } catch (err) {
        window.alert(err.message || T.strings.error);
      } finally {
        btn.disabled = false;
      }
    });
  }

  /* ---------- Fiche produit ---------- */
  function initProduct() {
    const root = $('[data-product]');
    if (!root) return;
    let product;
    try { product = JSON.parse($('[data-product-json]', root).textContent); } catch (e) { return; }

    const form = $('[data-product-form]', root);
    const idInput = $('[data-variant-id]', root);
    const addBtn = $('[data-add-btn]', root);
    const addLabel = $('[data-add-label]', root);
    const priceNow = $('[data-price-now]', root);
    const priceWas = $('[data-price-was]', root);
    const priceFrom = $('.price__from', root);
    const errorBox = $('[data-form-error]', root);
    const stickyPrice = $('[data-sticky-price]', root);
    const track = $('[data-gallery-track]', root);
    const thumbs = $$('[data-thumb]', root);
    const optionInputs = $$('[data-opt]', root);
    const galleryIndex = $('[data-gallery-index]', root);
    const priceBox = $('[data-price]', root);
    const stickyImg = $('.sticky-buy__img', root);
    const stickyAddBtn = $('[data-sticky-add]', root);
    const setIndex = (i) => { if (galleryIndex) galleryIndex.textContent = i + 1; };

    const currentOptions = () => {
      const values = [];
      optionInputs.forEach((el) => {
        const idx = Number(el.dataset.opt);
        if (el.tagName === 'SELECT') values[idx] = el.value;
        else if (el.checked) values[idx] = el.value;
      });
      return values;
    };

    const goToSlide = (index) => {
      if (!track) return;
      const slide = track.children[index];
      if (!slide) return;
      track.scrollTo({ left: slide.offsetLeft, behavior: reduced ? 'auto' : 'smooth' });
      thumbs.forEach((t, i) => t.classList.toggle('is-active', i === index));
      setIndex(index);
    };

    const updateVariant = () => {
      const values = currentOptions();
      const variant = product.variants.find((v) => v.options.every((o, i) => values[i] === undefined || o === values[i]));
      values.forEach((v, i) => { const label = $(`[data-opt-current="${i}"]`, root); if (label) label.textContent = v; });
      if (!variant) {
        if (addBtn) addBtn.disabled = true;
        if (addLabel) addLabel.textContent = T.strings.unavailable;
        return;
      }
      if (idInput) idInput.value = variant.id;
      if (priceFrom) priceFrom.remove();
      if (priceNow && priceNow.textContent !== money(variant.price)) {
        priceNow.textContent = money(variant.price);
        if (priceBox && !reduced) { priceBox.classList.remove('is-bump'); void priceBox.offsetWidth; priceBox.classList.add('is-bump'); }
      }
      if (stickyPrice) stickyPrice.textContent = money(variant.price);
      if (priceWas) {
        const sale = variant.compare_at_price && variant.compare_at_price > variant.price;
        priceWas.hidden = !sale;
        priceWas.textContent = sale ? money(variant.compare_at_price) : '';
      }
      if (addBtn) addBtn.disabled = !variant.available;
      if (stickyAddBtn) stickyAddBtn.disabled = !variant.available;
      if (stickyImg && variant.featured_image && variant.featured_image.src) {
        stickyImg.removeAttribute('srcset');
        stickyImg.src = variant.featured_image.src + (variant.featured_image.src.indexOf('?') > -1 ? '&' : '?') + 'width=120';
      }
      if (addLabel) addLabel.textContent = variant.available ? T.strings.addToCart : T.strings.soldOut;
      if (variant.featured_image && track) {
        const index = Array.from(track.children).findIndex((s) => s.dataset.imageId === String(variant.featured_image.id));
        if (index >= 0) goToSlide(index);
      }
      const url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url.toString());
    };

    optionInputs.forEach((el) => el.addEventListener('change', updateVariant));

    thumbs.forEach((t) => t.addEventListener('click', () => goToSlide(Number(t.dataset.thumb))));
    if (track && thumbs.length) {
      let timer;
      track.addEventListener('scroll', () => {
        clearTimeout(timer);
        timer = setTimeout(() => {
          const index = Math.round(track.scrollLeft / track.clientWidth);
          thumbs.forEach((t, i) => t.classList.toggle('is-active', i === index));
          setIndex(index);
        }, 80);
      }, { passive: true });
    } else if (track) {
      track.addEventListener('scroll', () => setIndex(Math.round(track.scrollLeft / track.clientWidth)), { passive: true });
    }

    // Motif sélectionné visible dans les pastilles
    $$('[data-swatches]', root).forEach((s) => {
      const checked = $('input:checked', s);
      if (!checked || s.scrollWidth <= s.clientWidth) return;
      const sw = checked.closest('.swatch');
      s.scrollLeft = sw.offsetLeft - s.clientWidth / 2 + sw.clientWidth / 2;
    });

    // Étoiles : défiler jusqu'aux avis
    $$('[data-scroll-reviews]', root).forEach((b) => b.addEventListener('click', () => {
      const w = document.querySelector('.jdgm-review-widget, .jdgm-rev-widg');
      if (w) window.scrollTo({ top: w.getBoundingClientRect().top + window.scrollY - 90, behavior: reduced ? 'auto' : 'smooth' });
    }));

    initLightbox(root, track);

    const qtyInput = $('.qty__input', root);
    $$('[data-qty-minus]', root).forEach((b) => b.addEventListener('click', () => { qtyInput.value = Math.max(1, (Number(qtyInput.value) || 1) - 1); }));
    $$('[data-qty-plus]', root).forEach((b) => b.addEventListener('click', () => { qtyInput.value = (Number(qtyInput.value) || 1) + 1; }));

    if (form) {
      form.addEventListener('submit', async (e) => {
        e.preventDefault();
        if (!addBtn || addBtn.disabled) return;
        if (errorBox) errorBox.hidden = true;
        addBtn.classList.add('is-loading');
        try {
          await addToCart(idInput.value, qtyInput ? qtyInput.value : 1);
          addBtn.classList.add('is-added');
          flyToCart(addBtn);
          setTimeout(() => refreshCart(true), 450);
          setTimeout(() => addBtn.classList.remove('is-added'), 1800);
        } catch (err) {
          if (errorBox) { errorBox.textContent = err.message || T.strings.error; errorBox.hidden = false; }
        } finally {
          addBtn.classList.remove('is-loading');
        }
      });
    }

    const sticky = $('[data-sticky-buy]', root);
    const stickyAdd = $('[data-sticky-add]', root);
    if (sticky && addBtn && 'IntersectionObserver' in window) {
      new IntersectionObserver(([e]) => {
        const show = !e.isIntersecting && e.boundingClientRect.top < 0;
        sticky.classList.toggle('is-visible', show);
        sticky.setAttribute('aria-hidden', show ? 'false' : 'true');
      }).observe(addBtn);
    }
    if (stickyAdd && form) stickyAdd.addEventListener('click', () => {
      if (form.requestSubmit) form.requestSubmit(); else form.dispatchEvent(new Event('submit', { cancelable: true }));
    });
  }

  /* ---------- Visionneuse plein écran ---------- */
  function initLightbox(root, track) {
    const lb = $('[data-lightbox]', root);
    if (!lb || typeof lb.showModal !== 'function') return;
    const lbTrack = $('[data-lightbox-track]', lb);
    const counter = $('[data-lightbox-index]', lb);
    const current = () => Math.round(lbTrack.scrollLeft / Math.max(1, lbTrack.clientWidth));
    const goTo = (i, smooth) => {
      const s = lbTrack.children[clamp(i, 0, lbTrack.children.length - 1)];
      if (s) lbTrack.scrollTo({ left: s.offsetLeft, behavior: smooth && !reduced ? 'smooth' : 'auto' });
    };
    const open = (i) => {
      $$('img', lb).forEach((img) => { img.loading = 'eager'; });
      lb.showModal();
      document.documentElement.style.overflow = 'hidden';
      requestAnimationFrame(() => goTo(i, false));
    };
    lb.addEventListener('close', () => { document.documentElement.style.overflow = ''; });
    $$('[data-zoom]', root).forEach((b) => b.addEventListener('click', () => {
      const i = b.dataset.zoom === 'current' && track ? Math.round(track.scrollLeft / Math.max(1, track.clientWidth)) : Number(b.dataset.zoom) || 0;
      open(i);
    }));
    const closeBtn = $('[data-lightbox-close]', lb);
    if (closeBtn) closeBtn.addEventListener('click', () => lb.close());
    lb.addEventListener('click', (e) => { if (e.target.classList.contains('lightbox__slide')) lb.close(); });
    const prev = $('[data-lightbox-prev]', lb), next = $('[data-lightbox-next]', lb);
    if (prev) prev.addEventListener('click', () => goTo(current() - 1, true));
    if (next) next.addEventListener('click', () => goTo(current() + 1, true));
    lb.addEventListener('keydown', (e) => {
      if (e.key === 'ArrowRight') goTo(current() + 1, true);
      if (e.key === 'ArrowLeft') goTo(current() - 1, true);
    });
    lbTrack.addEventListener('scroll', () => { if (counter) counter.textContent = current() + 1; }, { passive: true });
  }

  /* ---------- Livraison estimée & date limite de Noël ---------- */
  function initEta() {
    const box = $('[data-eta]');
    const fmt = (d) => d.toLocaleDateString('fr-FR', { weekday: 'short', day: 'numeric', month: 'short' });
    const addBusinessDays = (from, n) => {
      const d = new Date(from);
      let added = 0;
      while (added < n) {
        d.setDate(d.getDate() + 1);
        const wd = d.getDay();
        if (wd !== 0 && wd !== 6) added++;
      }
      return d;
    };
    if (box && T.strings.etaText) {
      const min = Number(box.dataset.min) || 8, max = Math.max(Number(box.dataset.max) || 15, min);
      const out = $('[data-eta-text]', box);
      const now = new Date();
      if (out) out.textContent = T.strings.etaText.replace('{from}', fmt(addBusinessDays(now, min))).replace('{to}', fmt(addBusinessDays(now, max)));
    }
    const x = $('[data-xmas]');
    if (x) {
      const parts = (x.dataset.xmas || '').split('-').map(Number);
      if (parts.length !== 3 || parts.some(isNaN)) return;
      const deadline = new Date(parts[0], parts[1] - 1, parts[2], 23, 59, 59);
      const days = Math.ceil((deadline - new Date()) / 86400000);
      if (days < 0 || days > 60) return;
      const dateEl = $('[data-xmas-date]', x), left = $('[data-xmas-left]', x);
      if (dateEl) dateEl.textContent = deadline.toLocaleDateString('fr-FR', { day: 'numeric', month: 'long' });
      if (left) left.textContent = days <= 1 ? T.strings.xmasLastDay : T.strings.xmasLeft.replace('{n}', days);
      x.hidden = false;
    }
  }

  /* ---------- Cartes : aperçu des motifs ---------- */
  function initCardDots() {
    const swap = (dot) => {
      const card = dot.closest('[data-card]');
      const img = card && $('.card__img--main', card);
      if (!img || img.dataset.cur === dot.dataset.dotSrc) return;
      img.dataset.cur = dot.dataset.dotSrc;
      img.removeAttribute('srcset');
      img.src = dot.dataset.dotSrc;
      if (!reduced) { img.classList.remove('is-swapping'); void img.offsetWidth; img.classList.add('is-swapping'); }
      card.classList.add('has-dot');
      $$('.card__dot', card).forEach((d) => d.classList.toggle('is-active', d === dot));
      const link = $('[data-card-link]', card);
      if (link && dot.dataset.dotUrl) link.href = dot.dataset.dotUrl;
    };
    document.addEventListener('click', (e) => {
      const dot = e.target.closest('[data-dot-src]');
      if (!dot) return;
      e.preventDefault();
      swap(dot);
    });
    if (finePointer) document.addEventListener('mouseover', (e) => {
      const dot = e.target.closest('[data-dot-src]');
      if (dot) swap(dot);
    });
  }

  /* ---------- Transitions entre les pages ---------- */
  function initPageTransitions() {
    if (reduced) return;
    let clickedImg = null;
    document.addEventListener('click', (e) => {
      const link = e.target.closest('a[href*="/products/"]');
      const card = link && link.closest('[data-card]');
      clickedImg = card ? $('.card__img--main', card) : null;
    }, true);
    window.addEventListener('pageswap', (e) => {
      if (!e.viewTransition || !clickedImg) return;
      const own = $('.gallery__slide:first-child .gallery__img');
      if (own) own.style.viewTransitionName = 'none';
      clickedImg.style.viewTransitionName = 'product-media';
    });
    window.addEventListener('pageshow', () => {
      $$('.card__img--main').forEach((img) => { img.style.viewTransitionName = ''; });
      const own = $('.gallery__slide:first-child .gallery__img');
      if (own) own.style.viewTransitionName = '';
    });
  }

  /* ---------- Barre de progression (navigateurs sans scroll-timeline) ---------- */
  function initProgress() {
    const bar = $('.scroll-progress');
    if (!bar) return;
    if (window.CSS && CSS.supports && CSS.supports('animation-timeline: scroll()')) return;
    let ticking = false;
    const update = () => {
      ticking = false;
      const h = document.documentElement.scrollHeight - window.innerHeight;
      bar.style.transform = `scaleX(${h > 0 ? clamp(window.scrollY / h, 0, 1).toFixed(4) : 0})`;
    };
    window.addEventListener('scroll', () => { if (!ticking) { ticking = true; requestAnimationFrame(update); } }, { passive: true });
    update();
  }

  /* ---------- Démarrage ---------- */
  const start = () => {
    initIntro();
    initReveal();
    initHeader();
    initScrollFx();
    initSnow();
    initPointerFx();
    initTypewriter();
    initDragScroll();
    initAccordions();
    initMenus();
    initCart();
    initProduct();
    initEta();
    initCardDots();
    initPageTransitions();
    initProgress();
    if (drawer) refreshCart(false);
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
